<template>
  <div>
    <span>{{ item.nome }} - {{ item.contato }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
    searchText: { required: true },
  },
}

</script>
